module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-square-c1c4237c.svg";